import React from 'react';
import { Input } from 'components/form-elements/inputs/Input';
import { LabeledElement } from 'components/form-elements/labels/LabeledElement';

export const LabeledInput = ({ 
  labelIntl, 
  id, 
  description, 
  descriptionPosition = 'bottom', 
  className,
  hasError,
  disabled,
  children,
  ...props 
}) => (
  <LabeledElement
    label={labelIntl}
    description={description}
    descriptionPosition={descriptionPosition}
    id={id}
  >
    <Input
      className={className}
      hasError={hasError}
      disabled={disabled}
      {...props}
    />
    {children}
  </LabeledElement>
);
